import Swiper from 'swiper/bundle';

function initSliderEvents() {
	const desktopBreakpoint = window.matchMedia("(min-width: 1220px)");

	document.querySelectorAll(".slide-events-container").forEach(slide => {
		const nextButton = slide.querySelector(".swiper-button-next");
		const prevButton = slide.querySelector(".swiper-button-prev");
		const isDesktopStatic = slide.classList.contains("slide-events-container--desktop-static");
		let swiper = null;

		const updateSlider = () => {
			if (isDesktopStatic && desktopBreakpoint.matches) {
				if (swiper) {
					swiper.destroy(true, true);
					swiper = null;
				}

				return;
			}

			if (swiper) {
				return;
			}

			swiper = new Swiper(slide, {
				slidesPerView: "auto",
				spaceBetween: 32,
				centeredSlides: true,
				grabCursor: true,

				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
			});
		};

		updateSlider();

		if (isDesktopStatic) {
			if (desktopBreakpoint.addEventListener) {
				desktopBreakpoint.addEventListener("change", updateSlider);
			} else {
				desktopBreakpoint.addListener(updateSlider);
			}
		}
	});
}

if (document.querySelector(".slide-events-container")) {
	initSliderEvents();
}
